<template>
    <div>
        <div class="label_loader">
            <div class="cssload-loader">
							<div class="cssload-inner cssload-one"></div>
							<div class="cssload-inner cssload-two"></div>
							<div class="cssload-inner cssload-three"></div>
						</div>
        </div>
        <div class="labelsContainer">
            <app-label v-for="label in labels" :label="label"></app-label>
            <app-stock v-if="stocks.length" v-for="stock in stocks" :stock="stock"></app-stock>
                     <div class="edit_order" v-show="edit_type =='order'">
                <div class="editOrderButton" @click="saveItemChanges($event)">
                    <span>{{strings.editOrder}}</span>
                </div>
            </div>
            <div class="button-set-cart" v-if="((this.$store.getters.labels.length) >1) || (this.$store.getters.stocks.length) ">

                <button   v-if="edit_type !='order'" @click="addToCart($event)" class="button lib-button-l add-to-cart cmpt">{{this.$store.getters.strings.addToCartString}}</button>
        </div>
    </div>
        <div :class="[{'is_active':this.$store.state.crosselings.active},'lightboxWrapper']" v-if="parseInt(this.$store.getters.strings.crosselings.length)">
            <div class="bg"></div>
                <div id="lightbox-product" class="lightbox-product">
                    <h3>{{this.$store.getters.strings.lightBoxProduct}}</h3>
                    <div class="lightbox_products">
                    <div class="product_inlight" v-for="label in labels">
                        <div :class="label.preview_type +' row added-product'">
                            <div class="col-sm-7">
                                <div class="a-product">
                                    <div class="a-image">
                                        <app-preview :label="label"></app-preview>
                                    </div>
                                    <div class="a-description">
                                        <strong class="a-product-name">{{label.name}}</strong>
                                        <span class="a-description">{{label.current_placeholder}} </span>

                                        <dl class="a-description-list">
                                            <div v-if="(label.lines.length && !parseInt(line.masterBlock))" v-for="line in label.lines" >
                                                <dt>{{line.title}}</dt>
                                                <dd v-model="line.text">{{line.text}}</dd>
                                            </div>
                                            <div v-if="typeof(label.cliparts)!='undefined' && label.cliparts.length" v-for="clipart in label.cliparts_blocks" class="test">
                                                <dt v-if="clipart.url!=''">{{getStringCliparts(label)}}</dt>
                                                <dd v-if="clipart.url!=''" class="with-icon"><span :style="getStyle(clipart)" class="a-description-icon"></span></dd>
                                            </div>
                                        </dl>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-5">
                                <div class="total-box">
                                    <span class="total-title">{{strings.cartTitle}}</span>
                                    <table class="total-table">
                                        <tbody><tr>
                                            <th>{{label.product_quantity}} {{strings.product_string}}</th>
                                            <td v-if="typeof(label.pq_quantities) != 'undefined'&& typeof(label.pq_quantities[label.current_qty_code]) != 'undefined'"> {{label.pq_quantities[label.current_qty_code]['price']}}</td>
                                        </tr>

                                        </tbody><tfoot>
                                        <tr>
                                            <th>{{strings.total}}</th>
                                            <td v-if="typeof(label.pq_quantities) != 'undefined' && typeof(label.pq_quantities[label.current_qty_code]) != 'undefined'"> {{label.pq_quantities[label.current_qty_code]['price']}}</td>
                                        </tr>
                                    </tfoot>
                                    </table>
                                    <a :href="strings.cartUrl" class="button order-button"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-Cart"></use></svg>{{strings.goToCart}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="a-related-block">
                        <h4 class="a-related-title">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-point"></use></svg> {{this.$store.getters.strings.relatedTitle}}
                        </h4>
                        <div class="a-related-list">
                            <div class="row">
                                <div class="col" v-for="crosseling in this.$store.getters.strings.crosselings">
                                    <div class="a-related-product">
                                        <div class="holder" >
                                            <div class="a-relate-image">
                                                <app-preview :label="getCorrectLines(crosseling['labels'][0])" v-if="parseInt(crosseling.is_label)"></app-preview>
                                                <img  v-if="!parseInt(crosseling.is_label)" class="product_image" :src="crosseling.product_image"/>
                                            </div>
                                            <h5 class="a-product-name">{{crosseling.product_name}}</h5>
                                            <span class="a-qty">{{crosseling.product_qty }}</span>
                                        </div>
                                        <div class="a-price-box">
                                            <span class="a-price">
                                                <span>{{crosseling.product_price}}</span>
                                            </span>
                                            <a v-if="parseInt(crosseling.is_label)" href="javascript:void(0)" @click="saveFrame(crosseling.prod_id)" class="action primary"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-Star-w"></use></svg>{{strings.personalizeRelated}}</a>
                                            <a v-if="!parseInt(crosseling.is_label)" :href="crosseling.product_url" class="action primary"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-Star-w"></use></svg>{{strings.personalizeRelated}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <a @click="closeModal($event)" data-fancybox-close="" href="#"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xlink:href="#icon-Delete"></use></svg>Close</a>
                </div>
        </div>
    </div>
</template>
<script>
    import Label from './Label.vue';
    import Preview from './Preview.vue';
    import Stock from './Stock.vue';

    export default {
        data(){
            return {
                isCrossellingActive : this.$store.getters.isCrossellingActive,
                strings             : this.$store.getters.strings,
                  edit_type:window.edit_type
            }
        },
        created () {
            this.$store.getters.strings.crosselings.forEach( function( element ) {
                store.dispatch( 'SETBACKGROUNDS', {record : element.labels[0]} );
            } );
        },
        components : {
            appLabel : Label,
            appPreview : Preview,
            appStock : Stock,
        },
        computed:{
             saveItemChanges  (event){
                this.$store.dispatch('generatePreview',{});
            },
            labels(){
                return this.$store.getters.labels;
            },
            stocks(){
                return this.$store.getters.stocks;
            },

        },
        methods : {
             addToCart (event  ) {
                event.preventDefault();
                  if ( this.$store.getters.strings.crosselings.length ) {
                      this.$store.dispatch( 'generatePreview', {} );
                }
                else {
                   this.$store.dispatch('generatePreview',{});
                }


            },
            addToCart2 ( event ) {
                event.preventDefault();
                  this.$store.dispatch('generatePreview',{});
            },
             getStyle (clipart){
                return {
                   'background-image' :clipart.url != "" ? "url(" + this.$store.getters.strings.getSvgUrl + "?category=" + clipart.category + "&filename=" + clipart.filename + "&color=0,83,128)" : 'none',
                }
            },
            getStringCliparts(label){
                return  this.$store.getters.strings.lightBoxCliparts
            },
            saveFrame  (prod_id){
                var params = {
                    single :1,
                    prod_id: prod_id
                }
                this.$store.dispatch('saveFrame',params);
            },
            getCorrectLines(element){
                 if(typeof (element['lines']) == "undefined")
                     return;
                var l= this.labels[0];
                element.use_icon =0;
                if ( typeof(element) != "undefined" ) {
                    if ( typeof(element['lines']) ) {
                        var lines = element['lines'];
                        if ( parseInt( element.use_master_block ) ) {
                            if ( typeof(l.lines) != "undefined" ) {
                                var masterBlock = element.lines.find( element => element.masterBlock == 1 );
                                if ( typeof(masterBlock) != "undefined" ) {
                                    masterBlock.text = "";
                                    var linesOriginal = [];
                                    var isCompleted = 0;
                                    var elementOriginal_index = 0;
                                    var totalLines = 0;
                                    var x = JSON.parse( JSON.stringify( l.lines ) )
                                   x.forEach( function( elementOriginal, ) {
                                        if ( ! parseInt( elementOriginal.masterBlock ) ) {
                                            if ( typeof (element['lines'][elementOriginal_index]) != 'undefined' ) {
                                                while ( parseInt( element['lines'][elementOriginal_index].masterBlock ) ) {
                                                    elementOriginal_index ++;
                                                }
                                                if ( ! parseInt( element['lines'][elementOriginal_index].masterBlock ) ) {
                                                    totalLines ++;
                                                    if ( elementOriginal.text.length > 0 || elementOriginal.placeholder.length > 0 ) {
                                                        isCompleted = 1;
                                                    }
                                                    if ( isCompleted ) {
                                                        linesOriginal.push( {
                                                            'text'        : elementOriginal.text,
                                                            'fontsize'    : element['lines'][elementOriginal_index].normal_font_size/* element['lines'][elementOriginal_index].min_font_size*/,
                                                            'block_name'  : elementOriginal.block_name,
                                                            'placeholder' : elementOriginal.placeholder,
                                                            'real_height' : elementOriginal.real_height
                                                        } );
                                                    }
                                                    element['lines'][elementOriginal_index]['fontsize'] = element['lines'][elementOriginal_index].normal_font_size ;
                                                    elementOriginal_index ++;
                                                }
                                            }

                                        }
                                    } );
                                    var no_lines = linesOriginal.length;
                                    var line_procent = 100 / totalLines;
                                    var editprocent = line_procent * no_lines;
                                    var emptyProcent = 100 - editprocent;
                                    var top = 0;
                                    var mastertext = "";
                                    linesOriginal.forEach( function( elementLines, index ) {
                                        top = emptyProcent / 2 + (line_procent / 2) + (line_procent * index);
                                        var text = elementLines.text;
                                        if ( text.length == 0 ) {
                                            text = elementLines.placeholder;
                                        }
                                        mastertext += "<span class='" + element.uniqueId + elementLines.block_name + "' style='text-align:" + masterBlock.alignment + ";max-height:" + (elementLines.real_height ) + "px;top:" + top + "%; font-size:" + elementLines.fontsize + "pt'>" + text + "</span>";
                                    } );
                                    masterBlock.text = mastertext;
                                }
                            }
                        }
                        else {
                            var elementOriginal_index= 0;
                            JSON.parse( JSON.stringify( l.lines ) ).forEach( function( elementOriginal, ) {
                                if ( ! parseInt( elementOriginal.masterBlock ) ) {
                                    if ( typeof (element['lines'][elementOriginal_index]) != 'undefined' ) {
                                        if ( parseInt( element['lines'][elementOriginal_index].masterBlock ) ) {
                                            elementOriginal_index ++;
                                        }
                                        if ( ! parseInt( element['lines'][elementOriginal_index].masterBlock ) ) {
                                           element['lines'][elementOriginal_index].text ="";
                                            if ( elementOriginal.text.length > 0 ) {
                                                element['lines'][elementOriginal_index].text = elementOriginal.text;
                                            }
                                            else {
                                                if ( elementOriginal.placeholder.length > 0 )
                                                    element['lines'][elementOriginal_index].text = elementOriginal.placeholder;
                                            }
                                            elementOriginal_index++;
                                        }
                                    }

                                }
                            } );
                        }

                        if ( typeof(element['cliparts_blocks']) ) {
                            var lines = element['cliparts_blocks'];
                            lines.forEach( function( element2, index ) {
                                if ( typeof (l['cliparts_blocks'][index]) != 'undefined' ) {
                                    if ( typeof(element.cliparts) != "undefined" ) {
                                        var cliparts = element.cliparts;
                                     if( l['cliparts_blocks'][index]['category'] != "") {
                                         if ( typeof (cliparts) != "undefined" ) {
                                             if ( typeof (cliparts[0]) != "undefined" ) {
                                                 if ( typeof (cliparts[0]['items'][1]) != "undefined" ) {
                                                     element2.filename = cliparts[0]['items'][1]['filename'];
                                                     element2.category = cliparts[0]['items'][1]['category'];
                                                     element2.url = cliparts[0]['items'][1]['url'];
                                                     //element2.rgb = l['cliparts_blocks'][index]['rgb'];
                                                 }
                                             }
                                         }
                                         cliparts.forEach( function( category, index_category ) {
                                             if ( category.category_name == l['cliparts_blocks'][index]['category'] ) {
                                                 if ( typeof (category.items) != "undefined" ) {
                                                     var items = category.items;
                                                     items.forEach( function( item, index_item ) {
                                                         if ( item.filename == l['cliparts_blocks'][index]['filename'] ) {
                                                             element2.filename = l['cliparts_blocks'][index]['filename']
                                                             element2.category = l['cliparts_blocks'][index]['category']
                                                             element2.url = l['cliparts_blocks'][index]['url']
                                                         }
                                                     } );
                                                 }
                                             }
                                         } );
                                     }
                                    }
                                }
                            } )
                        }
                        /*    if ( typeof(element['backgrounds']) ) {
                        var lines = element['backgrounds'];
                        lines.forEach( function( element2,index  ) {
                            if ( typeof (l['backgrounds'][index]) != 'undefined' ) {
                                element2.imagePath = l['backgrounds'][index]['imagePath']
                            }
                        } )
                    }*/
                    }
                }
            return element;
            },
            closeModal (event){
                 event.preventDefault();
                 var params = {
                     status :0
                 };
                this.$store.dispatch('setStatus',params);
            }
        }
    };
 </script>
<style>
    .labelsContainer {
        width   : 100%;
        display : inline-block;
    }

    #lightbox-product{
        background:#fff;
    }

    #lightbox-product .with-icon span
    {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .a-related-product .a-relate-image .previewComponent {
        height : 139px;
    }

    #lightbox-product {
        position   : relative;
        margin     : 0 auto;
        background : #FFFF;
        top        : 50%;
        transform  : translateY(-50%);
        overflow   : visible;
        max-height : 98%;
        overflow   : hidden;
        height     : 75%;

    }

    .lightboxWrapper {
        top      : -1500px;
        left     : -1500px;
        position : fixed;
    }

    .lightboxWrapper.is_active {
        position : fixed;
        width    : 100%;
        height   : 100%;
        top      : 0px;
        left     : 0px;
        z-index  : 99999999999;
    }

    .lightboxWrapper #canvasArea {
        padding-top : 0px;
    }
    .lightboxWrapper .bg {
        width      : 100%;
        height     : 100%;
        opacity    : 0.2;
        background : #000000;
        position   : absolute;
        top        : 0px;
    }

    .label_loader {
        width    : 100%;
        height   : 100%;
        display  : inline-block;
        position : absolute;
        top      : 0px;
        z-index  : 9999;
        display  : none;
    }

    .label_loader .wrapper,
    .labelLoader .wrapper
    {
        width      : 100%;
        height     : 100%;
        opacity    : 0.2;
        background : #000000;
    }

    .label_loader .cssload-loader,
    .labelLoader .cssload-loader
    {
        position  : fixed;
        top       : 50%;
        left      : 50%;
        transform : translate(-50%, -50%);
    }
.a-related-list .row{
    overflow:auto;
}

    .holder .product_image {
        height: 139px !important;
        width: auto !important;
        max-width: 100%;
        margin: 0 auto;
    }
    .a-related-block .masterBlock span{
        height:auto;
    }
    .lightbox_products{
        position       : absolute;
        margin         : 0 auto;
        /* background: #FFFF; */
        /* top: 50%; */
        /* transform: translateY(-50%); */
        overflow       : visible;
        max-height     : 98%;
        height         : 100%;
        overflow       : auto;
        width          : 100%;
        /* padding: 40px; */
        padding        : 24px 30px 0;
        left           : 0px;
        padding-top    : 0px;
        padding-bottom : 24px;
    }

    .lightbox-product h3
    {
        padding-right : 30px  ;
        padding       : 24px 0px 0px 24px  ;
        padding-top:0px;
    }

    .lightbox_products .product_inlight{
        display:none;
    }
    .lightbox_products .product_inlight:first-child{
        display:block ;
    }
</style>



// WEBPACK FOOTER //
// src/components/Labels.vue